import styles from '../styles/dashboard.module.scss'; 
import Navbar from '../components/NavigationBar';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import React from 'react';

const Dashboard = () => {
    const {user} = useContext(UserContext); 
    return (
        <div>
            <Navbar />
            <div className={styles.dashboard}>
                <h3 className={styles.dashboardTitle}>Üdv az event manager app adminjában, {user?.name}!</h3>
                <h4>CSV / XLS file importálas tudnivalók</h4>
                <p>- Engedélyezett file formátum: xlsx, xls, csv</p>
                <p style={{color: 'red'}}>- Az oszlopok sorrendjei: Név, Hozott vendégek száma, Custom1, Custom2, Custom3, Custom4</p>
                <p>- CSV összeállitásnál is ezt kellene figyelembe venni, tehát ebben a sorrendben legyenek az oszlopok</p>
                <p>- 2 fix oszlop van, 4 szabadon választható. A 4 egy maximum szám, tehát, ha kevesebb oszlop van a CSV-ben, akkor itt is kevesebb oszlop lesz.</p>
            </div>
        </div>
    )
}

export default React.memo(Dashboard);
